// extracted by mini-css-extract-plugin
export default {"button":"EllipsisShadowButton_button__spCSo"};